import { Time } from './src/Time'
export { Time }
export default Time



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Time/index.ts